/**
 * Landers + Offers blocks rendered inside the path detail. Each block wraps
 * BinomItemsList with the right CRUD callbacks + extra-add buttons.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, ReactNode } from 'react';

import type {
  BinomDraftItem,
  BinomDraftPath,
} from '../../binom-flow-draft.types';

import BinomItemsList from './BinomItemsList';

export interface BinomLandersOffersBlocksProps {
  path: BinomDraftPath;
  onPatch: (mutator: (p: BinomDraftPath) => void) => void;
  onAddLander: () => void;
  onRemoveLander: (idx: number) => void;
  onMoveLander: (from: number, to: number) => void;
  onEditLander: (item: BinomDraftItem) => void;
  onAddOffer: () => void;
  onRemoveOffer: (idx: number) => void;
  onMoveOffer: (from: number, to: number) => void;
  onEditOffer: (item: BinomDraftItem) => void;
  landerExtra: ReactNode;
  offerExtra: ReactNode;
}

const BinomLandersOffersBlocks: FC<BinomLandersOffersBlocksProps> = (props) => {
  const { path, onPatch } = props;
  return (
    <>
      <BinomItemsList
        kind="landers"
        pathId={path.id}
        items={path.landers}
        onItemWeight={(idx, w) =>
          onPatch((p) => {
            const t = p.landers[idx];
            if (t) t.weight = w;
          })
        }
        onItemActive={(idx, a) =>
          onPatch((p) => {
            const t = p.landers[idx];
            if (t) t.active = a;
          })
        }
        onRemove={props.onRemoveLander}
        onMove={props.onMoveLander}
        onAdd={props.onAddLander}
        onEditItem={(idx) => props.onEditLander(path.landers[idx])}
        extraAddButton={props.landerExtra}
      />
      <BinomItemsList
        kind="offers"
        pathId={path.id}
        items={path.offers}
        onItemWeight={(idx, w) =>
          onPatch((p) => {
            const t = p.offers[idx];
            if (t) t.weight = w;
          })
        }
        onItemActive={(idx, a) =>
          onPatch((p) => {
            const t = p.offers[idx];
            if (t) t.active = a;
          })
        }
        onRemove={props.onRemoveOffer}
        onMove={props.onMoveOffer}
        onAdd={props.onAddOffer}
        onEditItem={(idx) => props.onEditOffer(path.offers[idx])}
        extraAddButton={props.offerExtra}
      />
    </>
  );
};

export default BinomLandersOffersBlocks;
